import gas from '../../assets/img/energy/gas.svg';
import power from '../../assets/img/energy/power.svg';
import oil from '../../assets/img/energy/oil.svg';
import coal from '../../assets/img/energy/coal.svg';
import green from '../../assets/img/energy/green.svg';
import currency from '../../assets/img/energy/currency.svg';

const overviewCards = {
  gas: {
    title: 'Gas',
    icon: gas,
    evolution: {
      arrow: 1,
      price: 41.24,
      origin: 'NBP DA',
      currency: 'p/therm',
      decimals: 2,
    },
  },
  power: {
    title: 'Power',
    icon: power,
    evolution: {
      arrow: 1,
      price: 52.09,
      origin: 'UK DA Base',
      currency: '£ / MWh',
      decimals: 2,
    },
  },
  oil: {
    title: 'Brent Oil',
    icon: oil,
    evolution: {
      arrow: 1,
      price: 63.15,
      origin: 'Brent M+1',
      currency: '$/bbl',
      decimals: 2,
    },
  },
  coal: {
    title: 'Coal',
    icon: coal,
    evolution: {
      arrow: -1,
      price: 56.37,
      origin: 'Coal ARA CIF Cal Y+1',
      currency: '$/tonne',
      decimals: 2,
    },
  },
  green: {
    title: 'Carbon',
    icon: green,
    evolution: {
      arrow: -1,
      price: 41.17,
      origin: 'EUA Dec 25',
      currency: '€/tonne',
      decimals: 2,
    },
  },
  currency: {
    title: 'Currency',
    icon: currency,
    evolution: {
      arrow: -1,
      price: 1.16,
      origin: 'GBP/EUR',
      currency: '£/€',
      decimals: 4,
    },
  },
};

export default overviewCards;
